window.initializeVideoYoutubeControls = function (videoBlockEl) {
  if (typeof videoBlockEl === 'undefined') {
    return;
  }
  const isHero = videoBlockEl.classList.contains('youtube-video-hero');
  let cookieNotification = videoBlockEl.querySelector('.js-cookie-notification');
  if (cookieNotification) {
    cookieNotification.classList.add('hidden');
    cookieNotification.setAttribute('aria-hidden', true);
  }
  let iframe = videoBlockEl.querySelector('iframe');
  
  videoBlockEl.querySelector('.custom-controls').classList.add('initiated');
  if (iframe.getAttribute('data-autoplay') === 'true') {
    playVideo();
  }
  else {
    videoBlockEl.querySelector('.js-play-pause').addEventListener('click', (e) => {
      if ((!isHero && videoBlockEl.querySelector('.custom-controls').contains(e.target)) || (isHero && !videoBlockEl.querySelector('.custom-controls__play-pause').contains(e.target))) {
        return;
      }
      playVideo();
    }, true);
  }

  function playVideo() {
    videoBlockEl.classList.add('has-started');
    videoBlockEl.classList.add('playing');
    iframe.src = iframe.getAttribute('data-src');
  }
}